import { createFileRoute } from '@tanstack/react-router'
import { FeedbackPage } from '../../../features/platform/feedback-page'
import { feedbackSearchSchema } from '../../../features/platform/search'

export const Route = createFileRoute('/platform/_console/feedback')({
  validateSearch: feedbackSearchSchema,
  component: FeedbackPage,
})
